<template>
  <v-dialog scrollable v-model="dialog" @input="cancel" max-width="1140px">
    <v-card v-if="loaded && recibo.id">
      <v-card-title>Detalhes do recibo</v-card-title>
      <v-divider />

      <v-tabs v-model="tab" icons-and-text style="text-transform: uppercase;">
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#geral">
          Geral
          <v-icon>bookmark</v-icon>
        </v-tab>
        <v-tab href="#imagens">
          Imagens
          <v-icon>image</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items
        class="overflow-y-auto"
        style="max-height: 600px;"
        v-model="tab"
      >
        <v-tab-item value="geral">
          <v-card-text
            class="grey--text text--darken-4 text-body-1 d-flex flex-column py-5"
            style="gap: 8px"
          >
            <v-alert outlined type="error" v-if="recibo.canceled">
              <div class="d-flex align-content-center">
                <span>
                  Este recibo encontra-se cancelado.
                </span>
              </div>
            </v-alert>
            <v-row no-gutters>
              <v-col md="8" cols="12">
                <div class="d-flex">
                  <span class="font-weight-bold pr-1">Número:</span>
                  <span>{{ recibo.number }}</span>
                </div>
                <div class="d-flex">
                  <span class="font-weight-bold pr-1">Local:</span>
                  <span>
                    {{ `${recibo.address_street}, ${recibo.address_number}` }}
                  </span>
                </div>
                <div class="d-flex">
                  <span class="font-weight-bold pr-1">Referência:</span>
                  <span>{{ recibo.address_reference || "-" }}</span>
                </div>
                <p class="mb-0">
                  <span class="font-weight-bold">Observação:</span>
                  {{ recibo.observation || "-" }}
                </p>
              </v-col>

              <v-col md="4" cols="12">
                <div class="d-flex" v-if="recibo.type">
                  <span class="font-weight-bold pr-1">Tipo:</span>
                  <span>
                    {{ recibo.type }}
                  </span>
                </div>
                <div class="d-flex">
                  <span class="font-weight-bold pr-1">Data:</span>
                  <span>
                    {{ recibo.created_at | data }}
                  </span>
                </div>
                <div class="d-flex" v-if="recibo.deadline">
                  <span class="font-weight-bold pr-1">Prazo:</span>
                  <span>
                    {{ recibo.deadline | data }}
                  </span>
                </div>
                <div class="d-flex">
                  <span class="font-weight-bold pr-1">Agente:</span>
                  <span>
                    {{ recibo.agent.nickname }}
                  </span>
                </div>
                <div class="d-flex">
                  <span class="font-weight-bold pr-1">Matrícula:</span>
                  <span>
                    {{ recibo.agent.registration_number }}
                  </span>
                </div>
                <div class="d-flex" v-if="recibo.ebat_number">
                  <span class="font-weight-bold pr-1">BAT:</span>
                  <span>
                    {{ recibo.ebat_number || "Não informado" }}
                  </span>
                </div>
              </v-col>
            </v-row>

            <div class="py-3" v-if="recibo.aits">
              <v-divider />
              <v-row class="my-1">
                <v-col><span class="text-h6">Autos</span></v-col>
              </v-row>
              <v-alert
                outlined
                type="info"
                v-if="recibo.aits && !recibo.aits.length"
              >
                <div class="text-left">
                  <span>
                    Nenhum auto foi informado
                  </span>
                </div>
              </v-alert>
              <div v-else class="d-flex flex-column" style="gap: 8px">
                <v-row
                  no-gutters
                  v-for="(ait, index) in recibo.aits"
                  :key="index"
                >
                  <v-col md="3" cols="12">
                    <div class="d-flex">
                      <span class="font-weight-bold pr-1">AIT:</span>
                      <span>
                        {{ ait.number }}
                      </span>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="d-flex">
                      <span class="font-weight-bold pr-1">Enquadramento:</span>
                      <span>
                        {{ ait.code }}
                      </span>
                    </div>
                  </v-col>

                  <v-col md="12" cols="12">
                    <p class="mb-0">
                      <span class="font-weight-bold">Descrição:</span>
                      {{ ait.description }}
                    </p>
                  </v-col>
                </v-row>
              </div>
            </div>

            <div class="py-3">
              <v-divider />
              <v-row class="my-1">
                <v-col><span class="text-h6">Veículo</span></v-col>
              </v-row>
              <v-row no-gutters>
                <v-col md="5" cols="12">
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">Placa:</span>
                    <span>
                      {{ recibo.vehicle.license_plate || "-" }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">Renavam:</span>
                    <span>
                      {{ recibo.vehicle.renavam || "-" }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">Chassi:</span>
                    <span>
                      {{ recibo.vehicle.chassi || "-" }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">UF:</span>
                    <span>
                      {{ recibo.vehicle.uf || "-" }}
                    </span>
                  </div>
                </v-col>
                <v-col md="7" cols="12">
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">Marca/Modelo:</span>
                    <span>
                      {{ recibo.vehicle.brand || "-" }} /
                      {{ recibo.vehicle.model || "-" }}
                    </span>
                  </div>
                  <div class="d-flex" v-if="recibo.vehicle.odometer">
                    <span class="font-weight-bold pr-1">Hodômetro:</span>
                    <span v-if="recibo.vehicle.odometer">
                      {{ recibo.vehicle.odometer }} km
                    </span>
                    <span v-else>Não informado</span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">Proprietário:</span>
                    <span>
                      {{ recibo.vehicle.owner_name || "-" }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">
                      Proprietário documento:
                    </span>
                    <span>
                      {{ recibo.vehicle.owner_document || "-" }}
                    </span>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div class="py-3" v-if="!!recibo.tags">
              <v-divider />
              <v-row class="my-1">
                <v-col><span class="text-h6">Lacres</span></v-col>
              </v-row>
              <v-alert
                outlined
                type="info"
                v-if="recibo.tags && !recibo.tags.length"
              >
                <div class="text-left">
                  <span>
                    Nenhum lacre foi informado
                  </span>
                </div>
              </v-alert>
              <v-row no-gutters style="gap: 8px" v-else>
                <v-col
                  md="1"
                  cols="12"
                  :key="tag"
                  v-for="tag in recibo.tags"
                  class="teal lighten-4 text-center teal--text text--darken-4 py-1"
                >
                  {{ tag }}
                </v-col>
              </v-row>
            </div>

            <div class="py-3" v-if="recibo.driver">
              <v-divider />
              <v-row class="my-1">
                <v-col><span class="text-h6">Condutor</span></v-col>
              </v-row>
              <v-row no-gutters v-if="recibo.driver">
                <v-col md="7" cols="12">
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">Nome:</span>
                    <span>
                      {{ recibo.driver.name }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">CPF:</span>
                    <span v-if="recibo.driver.cpf">
                      {{ recibo.driver.cpf | cpf }}
                    </span>
                    <span v-else>-</span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">CNH:</span>
                    <span v-if="recibo.driver.cnh_number">
                      {{
                        `${recibo.driver.cnh_number} (${recibo.driver.cnh_uf})`
                      }}
                    </span>
                    <span v-else>Não habilitado</span>
                  </div>
                </v-col>

                <v-col md="5" cols="12" class="text-center mt-2">
                  <v-img
                    contain
                    height="70px"
                    :aspect-ratio="16 / 9"
                    v-if="recibo.driver.signature"
                    :src="`data:image/jpg;base64,${recibo.driver.signature}`"
                  />
                  <v-alert outlined type="warning" v-else>
                    <div class="text-left">
                      <span>
                        O condutor <b>recusou-se</b> a assinar este recibo
                      </span>
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
              <v-alert outlined type="error" v-else>
                <div class="d-flex align-content-center">
                  <span>
                    O condutor não foi identificado
                  </span>
                </div>
              </v-alert>
            </div>

            <div class="py-3" v-if="recibo.conductor">
              <v-divider />
              <v-row class="my-1">
                <v-col><span class="text-h6">Condutor indicado</span></v-col>
              </v-row>
              <v-row no-gutters v-if="recibo.conductor">
                <v-col md="7" cols="12">
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">Nome:</span>
                    <span>
                      {{ recibo.conductor.name }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">CPF:</span>
                    <span>
                      {{ recibo.conductor.cpf | cpf }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold pr-1">CNH:</span>
                    <span v-if="recibo.conductor.cnh_number">
                      {{
                        `${recibo.conductor.cnh_number} (${
                          recibo.conductor.cnh_uf
                        })`
                      }}
                    </span>
                    <span v-else>Não habilitado</span>
                  </div>
                </v-col>

                <v-col
                  md="5"
                  cols="12"
                  class="mt-2"
                  v-if="recibo.conductor.signature"
                >
                  <v-img
                    contain
                    height="70px"
                    v-if="recibo.conductor.signature"
                    :aspect-ratio="16 / 9"
                    :src="`data:image/jpg;base64,${recibo.conductor.signature}`"
                  />
                  <v-alert outlined dense type="error" v-else>
                    <span>
                      Sem assinatura
                    </span>
                  </v-alert>
                </v-col>
              </v-row>
            </div>

            <div class="py-3" v-if="recibo.documents">
              <v-divider />
              <v-row class="my-1">
                <v-col><span class="text-h6">Documentos</span></v-col>
              </v-row>
              <div class="d-flex flex-column" style="gap: 8px">
                <v-row
                  no-gutters
                  v-for="document in recibo.documents"
                  :key="document.number"
                >
                  <v-col md="2" cols="12">
                    <div class="d-flex flex-column">
                      <span class="font-weight-bold pr-1">Tipo:</span>
                      <span>
                        {{ document.type.toUpperCase() }} -
                        {{ document.specie }}
                      </span>
                    </div>
                  </v-col>

                  <v-col md="2" cols="12">
                    <div class="d-flex flex-column">
                      <span class="font-weight-bold pr-1">Número:</span>
                      <span>
                        {{ document.number }}
                      </span>
                    </div>
                  </v-col>

                  <v-col md="6" cols="12">
                    <div class="d-flex flex-column">
                      <span class="font-weight-bold pr-1">Nome:</span>
                      <span>
                        {{ document.name }}
                      </span>
                    </div>
                  </v-col>

                  <v-col md="2" cols="12">
                    <div class="d-flex flex-column">
                      <span class="font-weight-bold pr-1">Recolhido?</span>
                      <span>
                        {{ document.has_collected ? "Sim" : "Não" }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="imagens">
          <div class="px-4 py-4">
            <v-row
              v-if="recibo.images && recibo.images.length"
              cols="12"
              sm="9"
            >
              <v-col
                v-for="(image, index) in recibo.images"
                :key="index"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card flat tile class="d-flex">
                  <v-img
                    :src="'data:image/jpg;base64,' + image"
                    @click.stop="fullScreen(image, index)"
                    aspect-ratio="1"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
              <v-dialog v-model="showFullScreen" max-width="1050" isDark="">
                <v-card>
                  <div>
                    <v-btn
                      fab
                      dark
                      small
                      color="primary"
                      style="position:absolute;top:200px;left:10px;z-index:1"
                      @click="previous"
                      ><v-icon>mdi-chevron-left</v-icon></v-btn
                    >
                    <v-btn
                      fab
                      dark
                      small
                      color="primary"
                      style="position:absolute;right:10px;top:200px;z-index:1"
                      @click="next"
                      ><v-icon>mdi-chevron-right</v-icon></v-btn
                    >
                    <v-img :src="imgSrc" height="auto"></v-img>
                  </div>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="toggleFullScreen" color="red darken-1" text>
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-alert
              v-else
              text
              prominent
              color="blue"
              class="mt-4"
              icon="mdi-folder-multiple-image"
            >
              Nenhuma imagem foi encontrada para este recibo.
            </v-alert>
          </div>
        </v-tab-item>
      </v-tabs-items>

      <v-divider />
      <v-card-actions class="justify-end px-4 py-4">
        <v-btn color="primary" outlined @click="close">Fechar</v-btn>
      </v-card-actions>
    </v-card>

    <div v-else>
      <v-overlay :value="true">
        <v-progress-circular indeterminate size="64" />
      </v-overlay>
    </div>
  </v-dialog>
</template>
<script>
import urlApi from "@/routes/urlApi";

export default {
  name: "ModalDetalhesRecibo",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      tab: "general",
      recibo: {},
      dialog: false,
      loaded: false,
      imgSrc: "",
      showFullScreen: false,
      currentIndex: "",
    };
  },

  methods: {
    open(type, id) {
      this.dialog = true;

      this.$http
        .get(`${urlApi}/v2/recibos/${type}/${id}`)
        .then((response) => {
          this.recibo = response.data.recibo;
        })
        .finally(() => {
          this.loaded = true;
        });
    },
    cancel() {
      this.close();
    },
    previous() {
      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = this.recibo.images.length - 1;
      }
      const img = this.recibo.images[this.currentIndex];
      this.imgSrc = "data:image/jpg;base64," + img;
    },
    next() {
      this.currentIndex++;
      if (this.currentIndex === this.recibo.images.length) {
        this.currentIndex = 0;
      }
      const img = this.recibo.images[this.currentIndex];
      this.imgSrc = "data:image/jpg;base64," + img;
    },
    fullScreen(image, index) {
      this.imgSrc = "data:image/jpg;base64," + image;
      this.currentIndex = index;
      this.toggleFullScreen();
    },
    toggleFullScreen() {
      this.showFullScreen = !this.showFullScreen;
    },
    close() {
      this.tab = "general";
      this.recibo = {};
      this.dialog = false;
    },
  },
  mounted() {
    this.tab = "general";
  },
};
</script>
